import { from } from "rxjs";
import { selectBuildingPurchaseLevelRequirement } from "../../../../selectors/selectExistingBuildingInfo";
import { IdCharacterHelpType } from "../../../character-help-dialog/IdCharacterHelpType";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseCharacterHelpSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingPurchaseCharacterHelpMissingLevel = function (action, state$) {
    var building = action.building;
    var state = state$.value;
    var missingLevelRequirement = selectBuildingPurchaseLevelRequirement(state, building);
    var actions = [];
    if (missingLevelRequirement.missingPlayerLevel > 0) {
        var missingLevel = missingLevelRequirement.missingPlayerLevel;
        var characterHelpInfo = {
            missing: missingLevel.toString(),
            type: IdCharacterHelpType.MissingPlayerLevel,
        };
        actions.push(actionOngoingPurchaseCharacterHelpSelect(characterHelpInfo));
    }
    else if (missingLevelRequirement.missingPlayerAdventureLevel > 0) {
        var missingLevel = missingLevelRequirement.missingPlayerAdventureLevel;
        var characterHelpInfo = {
            missing: missingLevel.toString(),
            type: IdCharacterHelpType.MissingPlayerLevel,
        };
        actions.push(actionOngoingPurchaseCharacterHelpSelect(characterHelpInfo));
    }
    actions.push(actionModalOpen(IdModal.CharacterHelp));
    return from(actions);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingPurchaseCharacterHelpMissingLevel.ts
// module id = 2065
// module chunks = 3